export const ROLE_USER = 'ROLE_USER';
export const ROLE_EMPLOYEE = 'ROLE_EMPLOYEE';
export const ROLE_COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN';
export const ROLE_BMM_ADMIN = 'ROLE_BMM_ADMIN';
export const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const ROLE_SUPER_GROUP_ADMIN = 'ROLE_SUPER_GROUP_ADMIN';

export const ADMIN_ROLES = [ROLE_COMPANY_ADMIN, ROLE_BMM_ADMIN, ROLE_SUPER_ADMIN, ROLE_SUPER_GROUP_ADMIN];

export const ROLE_LEVELS = {
  [ROLE_USER]: 0,
  [ROLE_EMPLOYEE]: 1,
  [ROLE_COMPANY_ADMIN]: 2,
  [ROLE_SUPER_GROUP_ADMIN]: 3,
  [ROLE_BMM_ADMIN]: 4,
  [ROLE_SUPER_ADMIN]: 5,
};

export function hasRequiredRoleLevel(user, requiredRole) {
  const requiredLevel = ROLE_LEVELS[requiredRole];
  if (requiredLevel === undefined || !user?.roles?.length) return false;

  return user.roles.some((role) => {
    const roleLevel = ROLE_LEVELS[role];
    return roleLevel !== undefined && roleLevel >= requiredLevel;
  });
}
